import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscribe-page',
  templateUrl: './subscribe-page.component.html',
  styleUrls: ['./subscribe-page.component.css']
})
export class SubscribePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
